import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'
import { ReviewModel } from '../ngrx-store/app.state'
import { PpaReviewPager } from '../utils/ppa-review-pager'

/**
 * "Show more reviews" under a PPA's reviews (the PPA page and the card's reviews dialog): how many
 * are shown of how many, the button, and a retry when a page fails. `loaded` sends the reviews a
 * page added, so the list can move focus to the first of them.
 */
@Component({
  selector: 'app-ppa-reviews-more',
  templateUrl: './ppa-reviews-more.component.html',
})
export class PpaReviewsMoreComponent implements OnDestroy {
  @Input() pager!: PpaReviewPager

  /** All the PPA's reviews (its review_count), for "10 of 34". */
  @Input() total: number | null = null

  @Output() loaded = new EventEmitter<ReviewModel[]>()

  private destroy$ = new Subject<void>()

  get shown(): number {
    return this.pager.reviews.length
  }

  more(): void {
    if (this.pager.loadingMore) return
    this.pager.loadMore().pipe(takeUntil(this.destroy$)).subscribe({
      next: (added) => this.loaded.emit(added),
      error: () => undefined, // the pager says it failed - the template offers a retry
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }
}
